import { render, staticRenderFns } from "./variable__form.vue?vue&type=template&id=312a5e14"
import script from "./variable__form.vue?vue&type=script&lang=js"
export * from "./variable__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports